import { SimpleFooter } from "@cmsgov/ds-medicare-gov";
import { useTypedTranslate } from "../helpers/intlHooks";
import { useAppContext } from "../helpers/context-hooks/useAppContext";

export const Footer = () => {
  const {
    state: { language },
  } = useAppContext();
  const t = useTypedTranslate();

  return (
    <SimpleFooter
      language={language}
      aboutMedicareLabel={t("footer.about_medicare")}
      nondiscriminationLabel={t("footer.nondiscrimination_accessibility")}
      privacyPolicyLabel={t("footer.privacy_policy")}
      privacySettingLabel={t("footer.privacy_setting")}
      linkingPolicyLabel={t("footer.linking_policy")}
      usingThisSiteLabel={t("footer.using_this_site")}
      plainWritingLabel={t("footer.plain_writing")}
      websiteInfo={t("footer.website_info")}
    />
  );
};
